class FileType {
    id = 0;
    filename = "";
    sourcetype = 0;
    sourceId = "";
    ///sourcedetId = "";
    requestCorrelationId = crypto.randomUUID();
}

export {
    FileType
};